module.exports = __webpack_public_path__ + "static/media/moistrol-3.a1771443.jpg";